export default class RecipePart {
  constructor(part) {
    this.title = part.title;
    this.methodOfPreparation = part.methodOfPreparation;
  }
}
